export default function (flag, mods, value) {
    var quotes = flag.toLowerCase() === 'q';
    var result = String(value);
    if (mods.transform === '_') {
        result = String(value).toLowerCase();
    }
    if (mods.transform === '^' || flag === 'S' || flag === 'Q') {
        result = String(value).toUpperCase();
    }
    if (mods.padding) {
        result = result[mods.negative ? 'padEnd' : 'padStart'](mods.padding);
    }
    if (quotes) {
        return "\"".concat(escape(result), "\"");
    }
    return result;
}
